var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.file),expression:"file"}],ref:"box",staticClass:"preview-box"},[_vm._t("default"),_c('canvas',{ref:"canvas"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }